import { addMerchandise } from '@/app/order/checkout/action'
import Select from '@a24/form/Select'
import Button from '@a24/ui/Button'
import SanityImage from '@a24/ui/SanityImage'
import Title from '@a24/ui/Title'
import { useState, useTransition } from 'react'
import { useErrorToast, useSuccessToast } from '../toastHook'
import type { ISanityCheckoutMerch } from './type'

const MerchCard = ({
  id,
  price,
  title,
  variants,
  parentProduct
}: ISanityCheckoutMerch) => {
  const [actionState, setActionState] =
    useState<Awaited<ReturnType<typeof addMerchandise>>>()
  const [isPending, startTransition] = useTransition()
  const [selectedVariant, setSelectedVariant] = useState<string>(
    variants?.[0]?.priceValueId || ''
  )
  const handleAddToCart = () => {
    startTransition(async () => {
      // Add to cart logic here
      if (!id) return
      const res = await addMerchandise({
        merchandiseId: id,
        priceValueId: selectedVariant
      })
      startTransition(() => setActionState(res))
    })
  }

  useErrorToast(actionState)
  useSuccessToast(actionState, {
    overideMessage: 'Added to cart successfully!'
  })

  return (
    <article className='flex p-2 rounded border border-heritage-off-white-80 bg-heritage-white-full'>
      <div className='order-1 w-full flex justify-between flex-col'>
        <div className=''>
          {title && (
            <Title className='heading-xs pl-2' level='h3' text={title} />
          )}
          {price && (
            <span className='body-2xs mt-2 pl-2 text-heritage-off-white-40'>
              ${price}
            </span>
          )}
        </div>
        <div className='flex gap-4 justify-end'>
          {(variants?.length || 0) > 1 ? (
            <Select
              name='variant'
              className='pl-4! gap-4'
              onChange={setSelectedVariant}
              selectedOption={selectedVariant}
              options={
                variants
                  ?.filter((v) => Number(v.variantInventory) > 0)
                  ?.map((v) => ({
                    label: v.variantName || '',
                    value: v.priceValueId || ''
                  })) || []
              }
            />
          ) : (
            <div />
          )}
          <Button
            onClick={handleAddToCart}
            disabled={isPending}
            aria-disabled={isPending}
            type='button'
            className='w-fit button-secondary'
          >
            Add
          </Button>
        </div>
      </div>
      <SanityImage
        className='order-0 relative overflow-hidden bg-heritage-off-white-90 xl:max-w-[140px]'
        imageClassName='aspect-3/2 object-contain rounded w-full group-hover:scale-[105%] transition-card-image'
        sanityImageSourceData={
          parentProduct?.page?.image ||
          'https://cdn.sanity.io/images/sovogxyh/production/1d467bc1921cc305cf710c214102c694f70a0cd2-600x400.png'
        }
        height={384}
        width={480}
      />
    </article>
  )
}

export default MerchCard
